import { Link, Navigate, useLocation } from "react-router-dom";
import { PageLayout } from "../components/PageLayout";
import type { ReservationCreateResponse } from "../lib/api";
import { formatJstDateTime } from "../lib/format";
import { closeLiff } from "../lib/liff";
import type { ReservationDraft } from "../types";

const SECTION_LABEL: Record<"counter" | "zashiki", string> = {
  counter: "カウンター",
  zashiki: "掘りごたつ",
};

export function ReservationDonePage() {
  const location = useLocation();
  const state = location.state as {
    result?: ReservationCreateResponse;
    draft?: ReservationDraft;
  } | null;
  const result = state?.result;
  const draft = state?.draft;

  if (!result || !draft) return <Navigate to="/" replace />;

  return (
    <PageLayout title="ご予約完了">
      <div className="flex flex-col gap-4">
        <p className="rounded-md bg-emerald-50 px-3 py-3 text-sm text-emerald-800">
          ご予約を承りました。確定内容を LINE のトークでもお送りしています。
        </p>
        <div className="flex flex-col gap-2 rounded-md border border-neutral-200 p-4">
          <Row label="お席" value={SECTION_LABEL[result.confirmedSection]} />
          <Row label="日時" value={formatJstDateTime(toIso(draft.ymd, draft.time))} />
          <Row label="人数" value={`${draft.partySize}名`} />
          <Row label="お名前" value={draft.contactName} />
        </div>
        <Link
          to="/reservations"
          className="rounded-lg border border-neutral-300 px-4 py-3 text-center text-sm font-semibold"
        >
          ご予約の一覧へ
        </Link>
        <button
          type="button"
          onClick={() => closeLiff()}
          className="rounded-lg bg-neutral-900 px-4 py-3 text-sm font-semibold text-white"
        >
          閉じる
        </button>
      </div>
    </PageLayout>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline justify-between">
      <span className="text-xs text-neutral-500">{label}</span>
      <span className="ml-3 text-right text-sm font-medium">{value}</span>
    </div>
  );
}

function toIso(ymd: string, hhmm: string) {
  return `${ymd}T${hhmm}:00+09:00`;
}
